import { Component, HostListener, inject, ChangeDetectionStrategy } from '@angular/core';
import { rxResource, toSignal } from '@angular/core/rxjs-interop';
import { RequestTypes } from '@app/enums/RequestTypes';
import { RequestControllerv2Service } from '@app/generated-api/services/RequestControllerv2Service';
import { UserServiceV2 } from '@app/v2/services/user-service/user.service';
import { GenericRequest } from '@models/request';
import { AdminRequestServices } from '@services/admin/admin-request.service';
import { RequestStateService } from '@services/state-management/request-state.service';
import { Observable, map } from 'rxjs';

@Component({
    selector: 'medpace-request-history',
    standalone: false,
    templateUrl: './request-history.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./request-history.component.scss'],
})
export class RequestHistoryComponent {
    private adminRequestServices = inject(AdminRequestServices);
    private requestStateService = inject(RequestStateService);
    private userService = inject(UserServiceV2);
    private requestServiceV2 = inject(RequestControllerv2Service);

    @HostListener('window:scroll', []) onWindowScroll() {
        let history = document.getElementById('request-history');
        let scrollTop = document.documentElement.scrollTop;

        if (scrollTop <= 25) history.style.transform = 'translateY(0rem)';
        else history.style.transform = 'translateY(-6rem)';
    }
    elevatedAccess$ = this.userService.permissions.request.access.elevated$;

    requestType$: Observable<RequestTypes> = this.requestStateService
        .getRequest()
        .pipe(map((genericRequest) => this.getRequestExactType(genericRequest)));

    requestType = toSignal(this.requestType$);

    requestId = toSignal(this.requestStateService.getRequest().pipe(map((request) => request?.id)));

    requestHistoryPosts = rxResource({
        params: () => {
            if (!this.requestType() || !this.requestId()) return undefined;
            return { requestType: this.requestType(), requestId: this.requestId() };
        },
        stream: ({ params }) => {
            switch (params.requestType) {
                case RequestTypes.TRAVEL:
                    return this.requestServiceV2
                        .requestControllerv2GetTravelEventLogs(params.requestId)
                        .pipe(map((response) => response.logs));
                case RequestTypes.REIMBURSEMENT:
                    return this.requestServiceV2
                        .requestControllerv2GetReimbursementEventLogs(params.requestId)
                        .pipe(map((response) => response.logs));
                case RequestTypes.STIPEND:
                    return this.requestServiceV2
                        .requestControllerv2GetStipendEventLogs(params.requestId)
                        .pipe(map((response) => response.logs));
            }
        },
    });

    getRequestExactType(request: GenericRequest): RequestTypes {
        let exactType: RequestTypes;
        if (request.type === 'travel') {
            exactType = RequestTypes.TRAVEL;
        } else if (request.type === 'payment' || request.type === 'stipend' || request.type === 'out-of-pocket') {
            if (request.paymentType === 'stipend') {
                exactType = RequestTypes.STIPEND;
            } else if (request.paymentType === 'out-of-pocket') {
                exactType = RequestTypes.REIMBURSEMENT;
            }
        }
        return exactType;
    }
}
